import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SearchDoc } from '@shared/index';
import { firstValueFrom } from 'rxjs';

export type UserDocGroup = {
    userId: string;
    userName: string;
    docs: SearchDoc[];
};

@Injectable({
    providedIn: 'root'
})
export class UserDocsAdminService {

    private readonly baseUrl = '/api/toolbox/bot/admin/botdoc';

    constructor(private http: HttpClient) { }

    public async getUserDocuments(botId: string): Promise<{ grouped: UserDocGroup[] }> {
        return await firstValueFrom(this.http.get<{ grouped: UserDocGroup[] }>(`${this.baseUrl}/user-documents/${botId}`));
    }

    public async deleteUserDocument(docId: string): Promise<unknown> {
        return await firstValueFrom(this.http.delete(`${this.baseUrl}/user-document/${docId}`));
    }
}
